import HelpDeskRequestContainer from "../helpDesk/HelpDeskRequestContainer";
import HelpDeskRequestInput from "../helpDesk/HelpDeskRequestInput";
import HelpDeskRequest from "../../logic/helpDesk/helpDeskRequest";
import '../style/auth/signUp.css'
import LogoWithText from "../../../branding/component/logo/LogoWithText";
import {Button} from "../../../components/general/input/Button";

const DESCRIPTION = "Thank you for your interest in opening an account with us! Accounts are set up by " +
    "a sales representative. Please provide your contact information so we can get in contact with you to " +
    "set up an account."

const AFTER_SENT_MESSAGE = "Your signup request has been successfully submitted. We appreciate your interest and " +
    "will be in touch soon to complete the process.";

const SignUpContactForm = ({ onHide }) => {

    return (
        <>
            <div className="sign-up-logo">
                <LogoWithText />
            </div>
            <HelpDeskRequestContainer>
                <HelpDeskRequestInput
                    requestTypeID={HelpDeskRequest.TYPE_ID.NEW_ACCOUNT}
                    description={DESCRIPTION}
                    afterSentMessage={AFTER_SENT_MESSAGE}
                />
                {onHide &&
                    <Button
                        style={{marginTop: "8px"}}
                        className="button_clear"
                        onClick={onHide}
                    >
                        Back
                    </Button>
                }
            </HelpDeskRequestContainer>
        </>
    )
}

export default SignUpContactForm;